import React from 'react';
import { styled } from '@mui/material';
import { Checkbox, Row as FlexRow, Stack, Text } from 'library/ui';
import { Colors } from 'library';

export default function LocationRow({
    name,
    addressLine,
    createdBy,
    highlight,
    checked,
    disabled,
    onToggle,
    children,
}: {
    name?: string | null;
    addressLine: string;
    createdBy?: string;
    highlight: boolean;
    checked: boolean;
    disabled: boolean;
    onToggle: (checked: boolean) => void;
    children?: React.ReactNode;
}) {
    return (
        <Container $highlight={highlight}>
            <Stack gap="none">
                <Text weight="medium">{name || 'No location name found'}</Text>
                <Text size="sm" tone="secondary">
                    {addressLine}
                </Text>
                {(!!createdBy || highlight) && (
                    <FlexRow gap="sm" wrap>
                        {!!createdBy && (
                            <Text size="xs" tone="secondary">
                                {`Created by ${createdBy}`}
                            </Text>
                        )}
                        {highlight && (
                            <Text size="xs" tone="secondary">
                                This location
                            </Text>
                        )}
                    </FlexRow>
                )}
                {children}
            </Stack>
            <Checkbox
                checked={checked}
                onChange={(value) => {
                    if (disabled) return;
                    onToggle(value);
                }}
            />
        </Container>
    );
}

const Container = styled('div', { shouldForwardProp: (prop) => prop !== '$highlight' })<{ $highlight: boolean }>(
    ({ $highlight }) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
        padding: '8px 12px',
        borderRadius: 8,
        border: `1px solid ${$highlight ? Colors.secondary : 'transparent'}`,
        backgroundColor: $highlight ? Colors.surface : 'transparent',
    }),
);
